import script from "./upload.vue?vue&type=script&setup=true&lang=js"
export * from "./upload.vue?vue&type=script&setup=true&lang=js"

import "./upload.vue?vue&type=style&index=0&id=55e7f5a9&lang=scss"
import "./upload.vue?vue&type=style&index=1&id=55e7f5a9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e7f5a9"]])

export default __exports__